import React from "react";
import { AddInvestmentRestrictionsContainer } from "../../../containers";

const AddInvestmentRestrictions = (props) => {
  return <AddInvestmentRestrictionsContainer {...props} />;
};

export default AddInvestmentRestrictions;
